export default Object.freeze({
  // Reference is a main copy (most complete form of a set of duplicates).
  MAIN_COPY: 'MAIN_COPY',
  // Reference is a duplicate according to the user.
  USER_DUPLICATE: 'USER_DUPLICATE',
  // Reference is a duplicate according to the detection algorithm.
  AUTO_DUPLICATE: 'AUTO_DUPLICATE',
  // Reference is a potential duplicate according to the detection algorithm.
  POTENTIAL_DUPLICATE: 'POTENTIAL_DUPLICATE',
  // Reference is not a duplicate according to the user.
  NOT_DUPLICATE: 'NOT_DUPLICATE',
});
